import { render } from "./CommonOKDialog.vue?vue&type=template&id=7755cb7c&scoped=true&ts=true"
import script from "./CommonOKDialog.vue?vue&type=script&lang=ts"
export * from "./CommonOKDialog.vue?vue&type=script&lang=ts"

import "./CommonOKDialog.vue?vue&type=style&index=0&id=7755cb7c&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7755cb7c"]])

export default __exports__